import React, { useState, useContext } from "react";
import {Table, TableRow, TableCell, TableBody, TableHead, Button, TextField} from "@mui/material";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import { AppContext } from "../../App";
import CrewMember from "./CrewMember";



export default function Crew(){

  const {activeUser, setChangesMade} = useContext(AppContext)

  const members = activeUser.bandMembers

  const [open, setOpen] = useState(false);

  const [newMember, setNewMember] = useState({
    username: activeUser.username
  })

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleChange = (e) => {
    setNewMember({
      ...newMember,
      [e.target.name]: e.target.value
    })
  }

  console.log(activeUser)

  async function addNewMember(e){
    e.preventDefault()
    const newestMember = { ...newMember }

    await fetch("https://the-paper-pusher.herokuapp.com/members/add", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(newestMember)
    })
    .catch(error=>{
      window.alert(error)
      return
    })
    handleClose()
    setChangesMade(prev => prev+1)
  }
  

  return (
    <div className="contract-template">
      <h3>Band & Crew Members</h3> 

      {members.map(member => {
        return (

          <CrewMember name={member.name} id={member.id} 
                      dob={member.dob} phone={member.phone}
                      email={member.email} role={member.role}/>
          )
        })
      }
      

        
        <Button variant='contained' size='large' sx={{marginTop: '1em'}} onClick={handleClickOpen}>Add New</Button>
        <Dialog open={open} onClose={handleClose}>
          <DialogTitle>Add New Member</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Please fill in the details of the new member below:
            </DialogContentText>
            <TextField
              name="newMemberName"
              autoFocus
              margin="dense"
              id="newMemberName"
              label="Full Name(s)"
              type="text"
              fullWidth
              variant="standard"
              onChange={handleChange}
            />
            <TextField
              name="newMemberId"
              autoFocus
              margin="dense"
              id="newMemberID"
              label="ID Number"
              type="text"
              fullWidth
              variant="standard"
              onChange={handleChange}
            />
            <TextField
              name="newMemberDob"
              autoFocus
              margin="dense"
              id="newMemberDOB"
              label="yyyy/mm/dd - Date of Birth"
              type="date"
              fullWidth
              variant="standard"
              onChange={handleChange}
            />
            <TextField
              name="newMemberNumber"
              autoFocus
              margin="dense"
              id="newMemberContact"
              label="Contact Number"
              type="text"
              fullWidth
              variant="standard"
              onChange={handleChange}
            />
            <TextField
              name="newMemberEmail"
              autoFocus
              margin="dense"
              id="newMemberEmail"
              label="Email"
              type="text"
              fullWidth
              variant="standard"
              onChange={handleChange}
            />
            <TextField
              name="newMemberRole"
              autoFocus
              margin="dense"
              id="newMemberRole"
              label="Role"
              type="text"
              fullWidth
              variant="standard"
              onChange={handleChange}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            <Button onClick={addNewMember}>Add</Button>
          </DialogActions>
        </Dialog>



    </div>
  )
}